import React from "react";
import { render } from "react-dom";
// todo: add react-router

import App from "./components/app";

const Root = () => <App />;

render(<Root />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js